import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { LeaveAdjustment } from '../ILeaveAdjustment';

export const getAdjustments = createAction(
  '[LeaveAdjustment/API] Get LeaveAdjustments',
  props<{ PPS?: string, PPE?: string }>()
);

export const putRecalcAdjustments = createAction(
  '[LeaveAdjustment/API] PUT Recalc LeaveAdjustments',
  props<{ adjustments: Array<LeaveAdjustment>}>()
);

export const putAdjustments = createAction(
  '[LeaveAdjustment/API] PUT LeaveAdjustments',
  props<{ adjustments: Array<LeaveAdjustment>}>()
);

export const loadLeaveAdjustments = createAction(
  '[LeaveAdjustment/API] Load LeaveAdjustments',
  props<{ leaveAdjustments: LeaveAdjustment[] }>()
);

export const addLeaveAdjustment = createAction(
  '[LeaveAdjustment/API] Add LeaveAdjustment',
  props<{ leaveAdjustment: LeaveAdjustment }>()
);

export const upsertLeaveAdjustment = createAction(
  '[LeaveAdjustment/API] Upsert LeaveAdjustment',
  props<{ leaveAdjustment: LeaveAdjustment }>()
);

export const addLeaveAdjustments = createAction(
  '[LeaveAdjustment/API] Add LeaveAdjustments',
  props<{ leaveAdjustments: LeaveAdjustment[] }>()
);

export const upsertLeaveAdjustments = createAction(
  '[LeaveAdjustment/API] Upsert LeaveAdjustments',
  props<{ leaveAdjustments: LeaveAdjustment[] }>()
);

export const updateLeaveAdjustment = createAction(
  '[LeaveAdjustment/API] Update LeaveAdjustment',
  props<{ leaveAdjustment: Update<LeaveAdjustment> }>()
);

export const updateLeaveAdjustments = createAction(
  '[LeaveAdjustment/API] Update LeaveAdjustments',
  props<{ leaveAdjustments: Update<LeaveAdjustment>[] }>()
);

export const deleteLeaveAdjustment = createAction(
  '[LeaveAdjustment/API] Delete LeaveAdjustment',
  props<{ id: string }>()
);

export const deleteLeaveAdjustments = createAction(
  '[LeaveAdjustment/API] Delete LeaveAdjustments',
  props<{ ids: string[] }>()
);

export const clearLeaveAdjustments = createAction(
  '[LeaveAdjustment/API] Clear LeaveAdjustments'
);
